import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UrlBuilder } from '../core/url-builder/url-builder';
import { Injectable } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { UserStorage } from '../user/user-storage';
import { AudienceRoleName } from '../authentication/audience-role';

@Injectable()
export class AdminGuard implements CanActivate {

    constructor(private userStorage: UserStorage, private urlBuilder: UrlBuilder) {
    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const userRole = await this.userStorage.currentUser
            .pipe(
                map(u => u.metadata.audienceRole),
                first())
            .toPromise();
        const adminRoles: AudienceRoleName[] = ['Admin', 'Internal', 'System Admin'];
        if (adminRoles.indexOf(userRole) === -1) {
            this.urlBuilder.esa().navigate();
            return false;
        }

        return true;
    }
}